export default __webpack_public_path__ + "static/media/warning_amber-24px.528362b1.svg";